var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTemplewallet = function SvgTemplewallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1615 512",
    style: {
      enableBackground: "new 0 0 1615 512"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".templewallet_svg__st10{fill:#4a5568}")), /*#__PURE__*/React.createElement("g", {
    id: "templewallet_svg__Sketches"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "templewallet_svg__st10",
    d: "M475.8 198.7v-41.1h193.9v41.1h-72.3v194.9h-49.3V198.7h-72.3zM750 397c-18.2 0-33.9-3.7-47-11.1-13.1-7.4-23.2-17.9-30.3-31.6-7.1-13.6-10.6-29.8-10.6-48.5 0-18.2 3.5-34.2 10.6-47.9 7.1-13.8 17-24.5 29.9-32.2 12.9-7.7 28-11.5 45.4-11.5 11.7 0 22.6 1.9 32.7 5.6 10.1 3.7 18.9 9.3 26.5 16.8 7.6 7.5 13.5 16.8 17.7 28.1 4.2 11.3 6.3 24.4 6.3 39.5v13.5H681.8v-30.4h103.3c0-7.1-1.5-13.3-4.6-18.8-3.1-5.5-7.3-9.7-12.7-12.9-5.4-3.1-11.7-4.7-18.8-4.7-7.5 0-14 1.7-19.8 5.1-5.7 3.4-10.2 8-13.4 13.7-3.2 5.7-4.9 12.1-5 19.1v28.9c0 8.8 1.6 16.3 4.9 22.7 3.3 6.4 7.9 11.3 13.9 14.8s13.1 5.2 21.3 5.2c5.5 0 10.4-.8 15-2.3 4.5-1.5 8.4-3.8 11.6-6.9 3.2-3.1 5.7-6.8 7.4-11.3l45.4 3c-2.3 10.9-7 20.4-14.1 28.5-7.1 8.1-16.3 14.4-27.4 18.9-11.3 4.5-24.2 6.7-38.8 6.7zM863.3 393.6v-177h46.8v31.2h2.1c3.7-10.4 9.8-18.6 18.4-24.5 8.6-6 18.9-9 30.9-9 12.1 0 22.5 3 31 9s14.2 14.2 17.1 24.5h1.8c3.6-10.1 10.2-18.3 19.7-24.4 9.5-6.1 20.7-9.2 33.7-9.2 16.5 0 29.9 5.2 40.3 15.7 10.3 10.5 15.5 25.3 15.5 44.5v119.1h-49V284.2c0-9.8-2.6-17.2-7.8-22.1-5.2-4.9-11.8-7.4-19.6-7.4-8.9 0-15.9 2.8-20.9 8.5-5 5.6-7.5 13.1-7.5 22.3v108.1h-47.6V283.2c0-8.7-2.5-15.6-7.4-20.7-5-5.1-11.5-7.7-19.5-7.7-5.5 0-10.4 1.4-14.7 4.1s-7.8 6.5-10.3 11.4c-2.5 4.9-3.8 10.6-3.8 17.1v106.3h-49.2zM1159.3 460V216.5h48.4v29.7h2.2c2.2-4.8 5.3-9.6 9.4-14.6 4.1-5 9.5-9.1 16.1-12.4 6.6-3.3 14.9-5 24.8-5 12.9 0 24.8 3.4 35.7 10.1 10.9 6.7 19.6 16.8 26.2 30.3 6.5 13.5 9.8 30.4 9.8 50.7 0 19.7-3.2 36.4-9.5 50-6.3 13.6-14.9 23.8-25.8 30.8s-23 10.4-36.5 10.4c-9.5 0-17.6-1.6-24.3-4.7-6.6-3.1-12.1-7.1-16.3-11.9-4.2-4.8-7.5-9.7-9.7-14.6h-1.5V460h-49zm48-154.9c0 10.5 1.5 19.7 4.4 27.5 2.9 7.8 7.1 13.9 12.7 18.3 5.5 4.3 12.3 6.5 20.2 6.5 8 0 14.8-2.2 20.3-6.6 5.5-4.4 9.7-10.6 12.6-18.4 2.9-7.9 4.3-17 4.3-27.3 0-10.2-1.4-19.2-4.3-27-2.8-7.8-7-13.8-12.6-18.2-5.5-4.4-12.3-6.6-20.4-6.6-8 0-14.7 2.1-20.2 6.3-5.5 4.2-9.7 10.2-12.6 18-2.9 7.8-4.4 16.9-4.4 27.5zM1413.7 157.5v236h-49.1v-236h49.1zM1533.5 397c-18.2 0-33.9-3.7-47-11.1-13.1-7.4-23.2-17.9-30.3-31.6-7.1-13.6-10.6-29.8-10.6-48.5 0-18.2 3.5-34.2 10.6-47.9 7.1-13.8 17-24.5 29.9-32.2 12.9-7.7 28-11.5 45.4-11.5 11.7 0 22.6 1.9 32.7 5.6 10.1 3.7 18.9 9.3 26.5 16.8 7.6 7.5 13.5 16.8 17.7 28.1 4.2 11.3 6.3 24.4 6.3 39.5v13.5h-149.5v-30.4h103.3c0-7.1-1.5-13.3-4.6-18.8-3.1-5.5-7.3-9.7-12.7-12.9-5.4-3.1-11.7-4.7-18.8-4.7-7.5 0-14 1.7-19.8 5.1-5.7 3.4-10.2 8-13.4 13.7-3.2 5.7-4.9 12.1-5 19.1v28.9c0 8.8 1.6 16.3 4.9 22.7 3.3 6.4 7.9 11.3 13.9 14.8s13.1 5.2 21.3 5.2c5.5 0 10.4-.8 15-2.3 4.5-1.5 8.4-3.8 11.6-6.9 3.2-3.1 5.7-6.8 7.4-11.3l45.4 3c-2.3 10.9-7 20.4-14.1 28.5-7.1 8.1-16.3 14.4-27.4 18.9-11.2 4.5-24.1 6.7-38.7 6.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.385,
    y1: 236.308,
    x2: 354.462,
    y2: 236.308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    style: {
      stopColor: "#fcc33c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffee50"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_1_)"
    },
    d: "M275.7 157.5h78.8L315.1 0H39.4l39.4 157.5h78.7l39.4 157.6h-49.2l19.7 78.7h49.2l19.7 78.8h118.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.462,
    y1: 177.231,
    x2: 275.692,
    y2: 177.231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fb9828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f96c13"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_2_)"
    },
    d: "M315.1 196.9h-29.6l-9.8-39.4h78.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.485,
    y1: 68.923,
    x2: 93.538,
    y2: 68.923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f84200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f96c13"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_3_)"
    },
    d: "M275.7 78.8H98.5l-5-19.7h197z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.272,
    y1: 5.763,
    x2: 62.497,
    y2: 191.161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f96c13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb9828"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_4_)"
    },
    d: "M39.4 196.9 0 39.4 39.4 0l39.4 157.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 128,
    y1: 413.538,
    x2: 216.616,
    y2: 413.538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f84200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f96c13"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_5_)"
    },
    d: "M216.6 393.8h-49.2L128 433.2h49.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.385,
    y1: 177.231,
    x2: 157.538,
    y2: 177.231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f84200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f96c13"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_6_)"
    },
    d: "M118.2 196.9H39.4l39.4-39.4h78.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.711,
    y1: 320.864,
    x2: 134.426,
    y2: 163.301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f96c13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb9828"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_7_)"
    },
    d: "M196.9 315.1h-49.2l-29.5-118.2 39.3-39.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.137,
    y1: 427.462,
    x2: 124.555,
    y2: 320.846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fb9828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f96c13"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_8_)"
    },
    d: "m167.4 393.8-19.7-78.7-39.4 39.4 19.7 78.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.06,
    y1: 506.231,
    x2: 193.478,
    y2: 399.615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f96c13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb9828"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_9_)"
    },
    d: "m236.3 472.6-19.7-78.8-39.4 39.4 19.7 78.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.317,
    y1: 488.364,
    x2: 208.151,
    y2: 122.719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f96c13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f84200"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_10_)"
    },
    d: "m315.1 472.6-88.6-354.4-15.8 15.7 84.7 338.7-15.8 15.8h19.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.446,
    y1: 126.473,
    x2: 282.715,
    y2: 67.393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f84200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f96c13"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_11_)"
    },
    d: "M305.2 118.2h-19.7l-9.8-39.4 14.8-19.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "templewallet_svg__SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.443,
    y1: 492.308,
    x2: 331.117,
    y2: 492.308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f84200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f96c13"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#templewallet_svg__SVGID_12_)"
    },
    d: "m315.1 472.6-15.8 15.8h-19.7l15.8-15.8h-59.1L196.9 512h118.2l39.4-39.4z"
  })));
};

export { SvgTemplewallet as ReactComponent };
export default __webpack_public_path__ + "static/templewallet.a76c87fc.svg";